import moment from 'moment'
import { getToken } from './storage'
import { getCookie } from './cookies'

const baseFileStem = () =>
  `Billing Report — ${moment().format('YYYY-MM-DD')}`

const parseFilename = (contentDisposition, fallback) => {
  if (!contentDisposition) {
    return fallback
  }
  const match = /filename\*?=(?:UTF-8''|")?([^";]+)"?/i.exec(contentDisposition)
  if (match && match[1]) {
    return decodeURIComponent(match[1].trim())
  }
  return fallback
}

const triggerBlobDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/**
 * Download billing report CSV or PDF from the server.
 * @param {'csv'|'pdf'} format
 * @param {string} queryString - e.g. from createQueryString (status, search, siteSlug)
 */
export const downloadBillingReportExport = async (format, queryString = '') => {
  const token = getToken()
  if (!token) {
    return Promise.reject({ apiError: { message: 'unauthorized' } })
  }

  const separator = queryString && queryString.indexOf('?') === 0 ? '&' : '?'
  const qs =
    queryString && queryString.length > 0
      ? `${queryString}${separator}format=${format}`
      : `?format=${format}`

  const url = `${process.env.REACT_APP_API_BASE}/sites/billing-summary/export${qs}`

  const headers = {
    Authorization: token,
  }
  const csrfToken = getCookie('_csrf_token')
  if (csrfToken) {
    headers['X-CSRFToken'] = csrfToken
  }

  const response = await fetch(url, { method: 'GET', headers })

  if (!response.ok) {
    let apiError = {}
    const text = await response.text()
    try {
      apiError = JSON.parse(text)
    } catch (error) {
      const isGatewayError = response.status === 502 || response.status === 504
      apiError = {
        message: isGatewayError
          ? 'Export failed. Rebuild and redeploy the backend so billing export is available.'
          : text || 'Export failed',
      }
    }
    const message =
      apiError.message ||
      apiError.status?.message ||
      `Export failed (${response.status})`
    return Promise.reject(
      Object.assign(response, { apiError: { message } })
    )
  }

  const blob = await response.blob()
  const ext = format === 'pdf' ? 'pdf' : 'csv'
  const fallback = `${baseFileStem()}.${ext}`
  const filename = parseFilename(
    response.headers.get('Content-Disposition'),
    fallback
  )
  triggerBlobDownload(blob, filename)
}
